import {
  ACTIONS,
  ADD_REMOVE_COLUMNS,
  ADD_TOOLTIP,
  CANCEL_TOOLTIP,
  DELETE_TEXT,
  DELETE_TOOLTIP,
  EDIT_TOOLTIP,
  EMPTY_DATA_SOURCE_MESSAGE,
  EXPORT_ARIA_LABEL,
  EXPORT_CSV_NAME,
  EXPORT_TITLE,
  FILTER_TOOLTIP,
  FIRST_ARIA_LABEL,
  FIRST_TOOLTIP,
  GROUPED_BY,
  LABEL_DISPLAYED_ROWS,
  LABEL_ROWS_PER_PAGE,
  LABEL_ROWS_SELECT,
  LAST_ARIA_LABEL,
  LAST_TOOLTIP,
  NEXT_ARIA_LABEL,
  NEXT_TOOLTIP,
  N_ROWS_SELECTED,
  PLACEHOLDER,
  PREVIOUS_ARIA_LABEL,
  PREVIOUS_TOOLTIP,
  SAVE_TOOLTIP,
  SEARCH_PLACEHOLDER,
  SEARCH_TOOLTIP,
  SHOW_COLUMNS_ARIA_LABEL,
  SHOW_COLUMNS_TITLE,
} from "./constants";

const generateLocalization = (localization, t) => {
  return {
    body: {
      emptyDataSourceMessage: t(EMPTY_DATA_SOURCE_MESSAGE),
      addTooltip: t(ADD_TOOLTIP),
      deleteTooltip: t(DELETE_TOOLTIP),
      editTooltip: t(EDIT_TOOLTIP),
      filterRow: {
        filterTooltip: t(FILTER_TOOLTIP),
      },
      editRow: {
        deleteText: t(DELETE_TEXT),
        cancelTooltip: t(CANCEL_TOOLTIP),
        saveTooltip: t(SAVE_TOOLTIP),
      },
    },
    grouping: {
      placeholder: t(PLACEHOLDER),
      groupedBy: t(GROUPED_BY),
    },
    header: {
      actions: ACTIONS,
    },
    pagination: {
      labelDisplayedRows: t(LABEL_DISPLAYED_ROWS),
      labelRowsSelect: t(LABEL_ROWS_SELECT),
      labelRowsPerPage: t(LABEL_ROWS_PER_PAGE),
      firstAriaLabel: t(FIRST_ARIA_LABEL),
      firstTooltip: t(FIRST_TOOLTIP),
      previousAriaLabel: t(PREVIOUS_ARIA_LABEL),
      previousTooltip: t(PREVIOUS_TOOLTIP),
      nextAriaLabel: t(NEXT_ARIA_LABEL),
      nextTooltip: t(NEXT_TOOLTIP),
      lastAriaLabel: t(LAST_ARIA_LABEL),
      lastTooltip: t(LAST_TOOLTIP),
    },
    toolbar: {
      addRemoveColumns: t(ADD_REMOVE_COLUMNS),
      nRowsSelected: t(N_ROWS_SELECTED),
      showColumnsTitle: t(SHOW_COLUMNS_TITLE),
      showColumnsAriaLabel: t(SHOW_COLUMNS_ARIA_LABEL),
      exportTitle: t(EXPORT_TITLE),
      exportAriaLabel: t(EXPORT_ARIA_LABEL),
      exportCSVName: t(EXPORT_CSV_NAME),
      searchTooltip: t(SEARCH_TOOLTIP),
      searchPlaceholder: t(SEARCH_PLACEHOLDER),
    },
    ...localization,
  };
};

export default generateLocalization;
